/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* A single data point in the log histogram.
*/
export class LogsHistogramDataPoint {
  /**
  * The start timestamp of this data point.
  */
  'timestamp': Date;
  /**
  * The total count of logs in this time interval.
  */
  'count': number;
  /**
  * Breakdown of log counts by level (e.g., DEBUG, INFO, WARN, ERROR, FATAL). Keys are level names, values are counts. 
  */
  'levels'?: { [key: string]: number; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "timestamp",
      "baseName": "timestamp",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "count",
      "baseName": "count",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "levels",
      "baseName": "levels",
      "type": "{ [key: string]: number; }",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return LogsHistogramDataPoint.attributeTypeMap;
  }

  public constructor() {
  }
}

